

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferFailedDialogClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

